import request from '@/utils/http'
import global_var from '@/api/global_var.js'    //引用文件

// const BASE_URL = "http://118.89.164.56:8080/";
// const BASE_URL = "http://localhost:8080/";

const BASE_URL = global_var.baseURL

export const getIndexLooper = () => {
    return request.requestGet(BASE_URL+"portal/looper/list")
};

export const getRecommendList = () => {
    return request.requestGet(BASE_URL+"portal/recommend/list")
};

export const getAsideList = () => {
    return request.requestGet(BASE_URL+"portal/aside/list")
};

export const getMusicList = () => {
    return request.requestGet(BASE_URL+"portal/music/list")
};

export const getRootColumn = () => {
    return request.requestGet(BASE_URL+"portal/column/treeselect")
};

export const getLevel1Column = (rootColumnId) => {
    return request.requestGet(BASE_URL+"portal/column/list?parentId="+rootColumnId)
};

export const getArticleListByLevel1ColumnId = (level1ColumnId) => {
    // if (level1ColumnId === null || level1ColumnId === undefined || level1ColumnId === ''){
    //     return
    // }else {
    //     return request.requestGet(BASE_URL+"portal/article/list?columnId="+level1ColumnId)
    // }
    return request.requestGet(BASE_URL+"portal/article/list?columnId="+level1ColumnId)
};

export const getArticleListByPager = (level1ColumnId,pageNum,pageSize) => {
    return request.requestGet(BASE_URL+"portal/article/list?columnId="+level1ColumnId+"&pageNum="+pageNum+"&pageSize="+pageSize)
};

export const getArticleDetailByArticleId = (articleId) => {
    return request.requestGet(BASE_URL+"portal/article/"+articleId)
};

